import { Checkbox, Flex, Space } from "antd"
import classNames from "classnames"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import styles from "./StaffDaySelector.module.css"

const DAYS = [
  { value: "sunday" },
  { value: "monday" },
  { value: "tuesday" },
  { value: "wednesday" },
  { value: "thursday" },
  { value: "friday" },
  { value: "saturday" }
]

export const StaffDaySelector = ({ selectedDays, setSelectedDays }) => {
  const [t] = useTranslation()
  const handleDayToggle = (day) => {
    const newData = selectedDays?.includes(day) ? selectedDays?.filter((d) => d !== day) : [...selectedDays, day]
    setSelectedDays(newData)
  }

  return (
    <div className={styles.daySelector} wrap>
      {DAYS.map((day) => (
        <div key={day.value} className="flex-column align-center flex-1">
          <div
            className={classNames(styles.dayItem, selectedDays.includes(day.value) && styles.selected)}
            onClick={() => handleDayToggle(day.value)}
          >
            <Text variant="sub">{t(`staff.add_staff_modal.days.${day.value}`)}</Text>
          </div>
          <Checkbox checked={selectedDays.includes(day.value)} onChange={() => handleDayToggle(day.value)} className={styles.dayCheckbox} />
        </div>
      ))}
    </div>
  )
}

StaffDaySelector.propTypes = {
  selectedDays: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedDays: PropTypes.func.isRequired
}

export default StaffDaySelector
